import * as $ from 'jquery';
import * as React from 'react';
import Component from '../../../Component';
import SelectField from '../../../Components/SelectField';
import Submit from '../../../Components/Submit';
import ToggleField from '../../../Components/ToggleField';
import { leaveTypesOptionsFactory, officesOptionsFactory } from '../../../SelectOptionsFactories';

export default class Form extends Component {
    constructor(props: any) {
        super(props);
        this.state = {
            revertTransferToAnotherLeaveType: {
                rules: this.Rules().BasicSelectRules(),
                value: false
            },
            leaveType: {
                value: [],
                defaultValue: [],
                touched: false,
                rules: this.Rules().BasicSelectRules(),
            },
            revertTransferOnlyForTheFollowingOffices: {
                rules: this.Rules().BasicSelectRules(),
                value: false
            },
            offices: {
                value: [],
                defaultValue: [],
                touched: false,
                rules: this.Rules().BasicSelectRules(),
            },
            add: {
                pleaseWait: false
            },
        };
        this.transfer = this.transfer.bind(this);
    }

    render() {
        const t = this.translate();
        const caches: any = this.getCaches().getState();
        const leaveTypesOptions = leaveTypesOptionsFactory(caches.leaveTypes.arr, this.language());
        const officesOptions = officesOptionsFactory((this.getCaches().getState() as any).offices.arr);
        return <form onSubmit={(event: any) => { this.submit(event); }}>
            <div className="row">
                <div className="col-12 mb-3">
                    <ToggleField
                        defaultValue={this.state.revertTransferToAnotherLeaveType.value}
                        onChange={(value: any) => { this.setState({ revertTransferToAnotherLeaveType: Object.assign({}, this.state.revertTransferToAnotherLeaveType, { value: value }) }); }}
                    >
                        {t('revert.transfer.to.another.leave.type')}
                    </ToggleField>
                </div>
                {this.state.revertTransferToAnotherLeaveType.value ?
                    <div className="col-12 mb-3">
                        <SelectField
                            defaultValue={this.state.leaveType.value}
                            touched={this.state.leaveType.touched}
                            options={leaveTypesOptions}
                            multiple={false}
                            placeholder={t('leave.type')}
                            maxDisplayedOptions={3}
                            onChange={(value: any) => {
                                this.setState({ leaveType: Object.assign({}, this.state.leaveType, { value }) });
                            }}
                        />
                    </div>
                    : null}
                {officesOptions?.length > 1 ? <>
                    <div className="col-12 mb-3">
                        <ToggleField
                            defaultValue={this.state.revertTransferOnlyForTheFollowingOffices.value}
                            onChange={(value: any) => { this.setState({ revertTransferOnlyForTheFollowingOffices: Object.assign({}, this.state.revertTransferOnlyForTheFollowingOffices, { value: value }) }); }}
                        >
                            {t('revert.transfer.only.for.the.following.offices')}
                        </ToggleField>
                    </div>
                    {this.state.revertTransferOnlyForTheFollowingOffices.value ?
                        <div className="col-12 mb-3">
                            <SelectField
                                defaultValue={this.state.offices.value}
                                touched={this.state.offices.touched}
                                options={officesOptions}
                                multiple={true}
                                placeholder={t('offices')}
                                onChange={(value: any) => {
                                    this.setState({ offices: Object.assign({}, this.state.offices, { value }) },);
                                }}
                            />
                        </div> : null}
                </> : null}
                <div className="col-12 mb-3">
                    <Submit
                        faIcon="far fa-hdd"
                        disabled={!this.isFormValid()}
                        pleaseWait={this.state.add.pleaseWait}
                    >
                        {t('revert')}
                    </Submit>
                </div>
            </div>
        </form>
    }

    isFormValid() {
        return (this.state.revertTransferToAnotherLeaveType.value ? this.Validator().validate(this.state.leaveType) : true)
            && (this.state.revertTransferOnlyForTheFollowingOffices.value ? this.Validator().validate(this.state.offices) : true);
    }

    submit(event: any) {
        event.preventDefault();
        this.setState(
            { maximumTransferableDays: Object.assign({}, this.state.maximumTransferableDays, { touched: true }), },
            () => { if (this.isFormValid()) { this.transfer(); } }
        );
    }

    transfer() {
        const t = this.translate();
        $.ajax({
            type: 'POST',
            contentType: 'application/json',
            url: this.Endpoints().getLeaveTypeRevertTransfer(this.props.leaveType.id, this.props.year,
                this.state.revertTransferToAnotherLeaveType.value ? this.state.leaveType.value : undefined,
                this.state.revertTransferOnlyForTheFollowingOffices.value ? this.state.offices.value : undefined,
            ),
            dataType: 'json',
            cache: false,
            beforeSend: () => {
                this.setState({ revertTransferWait: true });
            },
            success: (data, textStatus, jqXHR) => {
                this.successToastr(t('the.transfer.was.reverted'));
                if (this.props.onClose) {
                    this.props.onClose();
                }
            },
            complete: () => {
                this.setState({ revertTransferWait: false });
            },
            error: (jqXHR, textStatus, errorThrown) => {
                this.generalErrorToastr();
            }
        });
    }
}